<template>
  <div>
    <van-row class="bmTitle">
      <van-col span="24">
        <h2>申请发票</h2>
      </van-col>
    </van-row>
    <van-row class="bmForm">
      <van-col span="24">
        <van-notice-bar style="font-size: 16px;" v-if="meeting.invoiceDeadline">
        	温馨提示：发票申请截止至{{meeting.invoiceDeadline.split(' ')[0]}}，如有疑问请联系会议主办方。
        	<template #left-icon>
        		<van-icon name='info-o' size="20" style="margin-right: 10px;" />
        	</template>
        </van-notice-bar>
        <van-form @submit="onSubmit">
          <div class="formInput hide"><van-field v-model="invoice.invoiceType" name="invoiceType" label="id" /></div>
          <div class="formInput">
            <van-field
              v-model="invoice.invoiceTitle"
              name="invoiceTitle"
              placeholder="请填写发票抬头"
              label="发票抬头"
              clearable
              required
              :rules="[{ required: true, message: '请填写发票抬头' }]"
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="invoice.taxpayerIdentificationNumber"
              name="taxpayerIdentificationNumber"
              placeholder="请填写税务登记号"
              label="税务登记号"
              clearable
              required
              :rules="[{ required: true, message: '请填写税务登记号' }]"
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="invoice.bankOfDeposit"
              name="bankOfDeposit"
              placeholder="请填写开户银行名称"
              label="开户银行名称"
              clearable
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="invoice.accountOpening"
              name="accountOpening"
              placeholder="请填写基本开户账号"
              label="基本开户账号"
              clearable
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="invoice.companyAddress"
              name="companyAddress"
              placeholder="请填写注册场所地址"
              label="注册场所地址"
              clearable
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="invoice.contactTelephoneCompany"
              name="contactTelephoneCompany"
              placeholder="请填写注册固定电话"
              label="注册固定电话"
              clearable
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="invoice.recipientEmail"
              name="recipientEmail"
              placeholder="请输入发票收件人邮箱"
              label="发票收件人邮箱"
              clearable
              required
              :rules="[{ pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, required:true, message: '请输入正确发票收件人邮箱'}]"
            />
          </div>
          <div style="margin:30px 16px 16px;">
            <van-button round block  type="info" native-type="submit">保存</van-button>
            <van-button round block  type="danger" native-type="button" @click="cancelInvoice(orderList)" v-if="orderList.length>0&&orderList[0].orderInvoice" style="margin-top: 10px;">取消发票</van-button>
          </div>
        </van-form>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
		invoice:{
			invoiceType:1,
			invoiceTitle:'',//发票抬头
			taxpayerIdentificationNumber:'',//税务登记号
			bankOfDeposit:'',//开户银行名称
			accountOpening:'',//基本开户账号
			companyAddress:'',//注册场所地址
			contactTelephoneCompany:'',//注册固定电话
			recipientEmail:'',//发票收件人邮箱
		},
		meeting:{},
		orderList:[],
      fpxxEndTime:localStorage.getItem('sqfpEndTime')
    };
  },
  methods: {
    onSubmit(values) {
      values.invoiceType = parseInt(this.invoiceType);
      console.log(values);
      const hyMeetingId = sessionStorage.getItem('meetingId');
      const token = localStorage.getItem('sessionGrzxToken_'+hyMeetingId);
      // this.$dialog.alert({
      //     message: '系统发票申请时间已截止，如需开票，请于<span style="color:red;">4月19日</span>前将参会人员姓名、联系电话及开票信息发送至<a style="text-decoration:underline;" href="mailto:chmia2021@163.com">chmia2021@163.com</a>，我们将在会后<span style="color:red;">2周内</span>将电子发票发送至您邮箱。',
      // })
      this.axios.post('/api/appweb/orderDetails/applyOrderInvoice/'+hyMeetingId,values,{ headers: {  Authorization: ` ${token}`  } }).then((res)=>{
        const data = res.data;
        
        if(data.status == 200){
          this.$dialog.alert({
            message: data.data,
          }).then(() => {
            // on close
            this.$router.push('/personal/index');
          });
        }
      })
    },
	//取消申请发票
	cancelInvoice(item) {
		this.$dialog.confirm({
			// title: '取消申请发票',
			message: '确定取消申请发票？',
		}).then(() => {
			// on close
			const hyMeetingId = sessionStorage.getItem('meetingId');
			const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
			var data = {
				"meetingId": hyMeetingId
			}
			this.axios.post('api/appweb/orderDetails/cancelOrderInvoice/' + hyMeetingId, data, {
				headers: {
					Authorization: ` ${token}`
				}
			}).then((res) => {
				const data = res.data;
				if (data.status == 200) {
					this.$dialog.alert({
						message: data.data,
					}).then(() => {
						// on close
						this.toEnteredCenter();
						this.$router.push('/personal/index');
					});
				}
			})
		}).catch(() => {
			// on cancel
		})
	},
	toEnteredCenter() {
		const hyMeetingId = sessionStorage.getItem('meetingId');
		const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
		if (!token) {
			this.$router.push('/personal/login?meetingId=' + hyMeetingId);
			return false;
		} else {
			this.axios.get('/api/appweb/entered/toEnteredCenter/' + hyMeetingId, {
				headers: {
					Authorization: ` ${token}`
				}
			}).then(res => {
				// console.log(res.data.data);
				if (res.data.status == 200) {
					if (res.data.data.meeting) {
						this.meeting = res.data.data.meeting;
						this.orderList = res.data.data.orderList;
						if(this.orderList[0].orderInvoice){
							var orderInvoice = JSON.parse(this.orderList[0].orderInvoice);
							if(orderInvoice){
								this.invoice = orderInvoice;
							}
						}
						
					}
				}
			});
		}
	},
    fhgrzx(){
      this.$router.push('/personal/index')
    }
  },
  created(){
    this.toEnteredCenter();
  }
};
</script>

<style scoped="scoped">
  .hide{
    display: none;
  }
.bmForm {
  padding: 20px 0;
}
.bmTitle {
  padding: 0px 20px 10px;
  line-height: 40px;
  background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
}
.bmTitle h2 {
  font-weight: normal;
  font-size: 30px;
}
.formInput {
  padding: 4px 0;
  margin: 0 20px;
  border-bottom: 1px solid #e8e8e8;
}
.lineddd {
  height: 3px;
  background-color: #e8e8e8;
  margin-top: -1px;
}
.van-cell,
.van-button {
  font-size: 16px;
}
.van-cell::after {
  border-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Personal/sqfp.vue